import {
  CheckINOutAttendee,
  CheckinOutAttendeeWithType,
  RollCallResp,
} from 'types/event/eventAttendance'
import { Person } from 'types/globalTypes'
import { create } from 'zustand'

const eventAttendance = (set: any) => ({
  // modals
  attendanceModalOpen: false,
  setAttendanceModalOpen: (state: boolean) =>
    set(() => ({ attendanceModalOpen: state })),
  checkInOutModalOpen: false,
  setCheckInOutModalOpen: (state: boolean) =>
    set(() => ({ checkInOutModalOpen: state })),
  checkInModalOpen: false,
  setCheckInModalOpen: (state: boolean) =>
    set(() => ({ checkInModalOpen: state })),
  approveCheckInModal: false,
  setApproveCheckInModal: (state: boolean) =>
    set(() => ({ approveCheckInModal: state })),
  checkOutModalOpen: false,
  setCheckOutModalOpen: (state: boolean) =>
    set(() => ({ checkOutModalOpen: state })),
  dropInModalOpen: false,
  setDropInModalOpen: (state: boolean) =>
    set(() => ({ dropInModalOpen: state })),
  detailedDropInModalOpen: false,
  setDetailedDropInModalOpen: (state: boolean) =>
    set(() => ({ detailedDropInModalOpen: state })),
  detailedDropOutModalOpen: false,
  setDetailedDropOutModalOpen: (state: boolean) =>
    set(() => ({ detailedDropOutModalOpen: state })),
  addDropInAttendeeModalOpen: false,
  setAddDropInAttendeeModalOpen: (state: boolean) =>
    set(() => ({ addDropInAttendeeModalOpen: state })),
  dropOutModalOpen: false,
  setDropOutModalOpen: (state: boolean) =>
    set(() => ({ dropOutModalOpen: state })),
  accountNotFoundModalOpen: false,
  setAccountNotFoundModalOpen: (state: boolean) =>
    set(() => ({ accountNotFoundModalOpen: state })),
  accountFoundModalOpen: false,
  setAccountFoundModalOpen: (state: boolean) =>
    set(() => ({ accountFoundModalOpen: state })),
  checkInOutExportModalOpen: false,
  setCheckInOutExportModalOpen: (state: boolean) =>
    set(() => ({ checkInOutExportModalOpen: state })),
  checkOutFromThisDeviceModalOpen: false,
  setCheckOutFromThisDeviceModalOpen: (state: boolean) =>
    set(() => ({ checkOutFromThisDeviceModalOpen: state })),
  rollCallModalOpen: false,
  setRollCallModalOpen: (state: boolean) =>
    set(() => ({ rollCallModalOpen: state })),
  addNewMemberModalOpen: false,
  setAddNewMemberModalOpen: (state: boolean) =>
    set(() => ({ addNewMemberModalOpen: state })),
  exportTicketModalOpen: false,
  setExportTicketModalOpen: (state: boolean) =>
    set(() => ({ exportTicketModalOpen: state })),
  importRegistrationsModalOpen: false,
  setImportRegistrationsModalOpen: (state: boolean) =>
    set(() => ({ importRegistrationsModalOpen: state })),

  // data sets
  familyEmail: null,
  setFamilyEmail: (state: string) => set(() => ({ familyEmail: state })),
  familyId: null,
  setFamilyId: (state: string) => set(() => ({ familyId: state })),
  participantData: null,
  setParticipantData: (state: CheckinOutAttendeeWithType) =>
    set(() => ({ participantData: state })),
  dropInAttendeeData: null,
  setDropInAttendeeData: (
    state: Person & { type: 'kid' | 'authorizedAdult' | 'guardian' },
  ) => set(() => ({ dropInAttendeeData: state })),
  dropInPricing: null,
  setDropInPricing: (state: number) => set(() => ({ dropInPricing: state })),
  checkInFamilyMembers: null,
  setCheckInFamilyMembers: (state: any) =>
    set(() => ({ checkInFamilyMembers: state })),
  selectedDate: new Date(),
  setSelectedDate: (state: Date | string) =>
    set(() => ({ selectedDate: state })),
  rollCallData: null,
  setRollCallData: (state: RollCallResp) =>
    set(() => ({ rollCallData: state })),
})

export const eventAttendanceStore = create(eventAttendance)
